export type Theme = {
  colorScheme: string;
  fontSrcCss: string;
  fontFamily: string;

  modalBorderWidth: string;
  modalBorderRadius: string;

  colorModalBackgroundLinearGradient: string;

  buttonPrimaryForeground: string;
  buttonPrimaryBackground: string;
  buttonPrimaryBorderColor: string;
  buttonPrimaryBorderWidth: string;
  buttonPrimaryBorderRadius: string;
  buttonPrimaryPadding: string;

  buttonSecondaryBackground: string;
  buttonSecondaryBorderColor: string;
  buttonSecondaryBorderWidth: string;
  buttonSecondaryBorderRadius: string;
  buttonSecondaryPadding: string;

  alertBackground: string;
  alertBorderWidth: string;

  colorModalBackdrop: string;
  colorModalBackground: string;
  colorModalBorder: string;
  colorTextPrimary: string;
  colorTextSecondary: string;
  colorPrimaryButtonBackground: string;
  colorBackgroundSecondary: string;
  colorAlertBackground: string;
  colorAlertAccent: string;
  colorAlertWarningBackground: string;
  colorAlertWarningAccent: string;
  colorAlertBorder: string;

  appLogoHeight: string;
};

export function createDefaultTheme(): Theme {
  return {
    colorScheme: "normal",
    fontSrcCss: "",
    fontFamily: "",

    modalBorderWidth: "1px",
    modalBorderRadius: "1rem",

    colorModalBackgroundLinearGradient: "",

    buttonPrimaryForeground: "#ffffff",
    buttonPrimaryBackground: "#262626",
    buttonPrimaryBorderColor: "transparent",
    buttonPrimaryBorderWidth: "0px",
    buttonPrimaryBorderRadius: "0.5rem",
    buttonPrimaryPadding: "0.5rem",

    buttonSecondaryBackground: "#f5f5f5",
    buttonSecondaryBorderColor: "transparent",
    buttonSecondaryBorderWidth: "0px",
    buttonSecondaryBorderRadius: "0.375rem",
    buttonSecondaryPadding: "0.5rem",

    alertBackground: "#f5f5f5",
    alertBorderWidth: "0px",

    colorModalBackdrop: "#f5f5f5",
    colorModalBackground: "#ffffff",
    colorModalBorder: "#f5f5f5",

    colorTextPrimary: "#171717",
    colorTextSecondary: "#a3a3a3",
    colorPrimaryButtonBackground: "#262626",

    colorBackgroundSecondary: "#f5f5f5",

    colorAlertBackground: "#f5f5f5",
    colorAlertAccent: "#171717",
    colorAlertWarningBackground: "#fed7aa",
    colorAlertWarningAccent: "#f97316",
    colorAlertBorder: "transparent",

    appLogoHeight: "2rem",
  };
}
